import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.groupContractHoldChart = echarts.init(this.element.querySelector('#group-contract-hold-chart'));
    this.groupContractHoldPerDeptChart = echarts.init(this.element.querySelector('#group-contract-hold-per-dept-chart'));

    var companyCodes = JSON.parse(this.data.get("company_codes"));
    var companyShortNames = JSON.parse(this.data.get("company_short_names"));
    const currentUserCompaniesShortNames = JSON.parse(this.data.get("current_user_companies_short_names"));
    var bizRetentContract = JSON.parse(this.data.get("biz_retent_contract"));
    var bizRetentNoContract = JSON.parse(this.data.get("biz_retent_no_contract"));
    var bizRetentTotals = JSON.parse(this.data.get("biz_retent_totals"));
    var bizRetentTotalsPerWorker = JSON.parse(this.data.get("biz_retent_totals_per_worker"));
    var bizRetentTotalsPerStaff = JSON.parse(this.data.get("biz_retent_totals_per_staff"));
    var bizRetentTotalsGap = JSON.parse(this.data.get("biz_retent_totals_gap"));

    var option = {
        legend: {
            data: ['业务保有量合计（万元）','已签约的业务保有量（万元）','未签约的业务保有量（万元）'],
            align: 'left'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        grid: {
          left: 70,
          right: 110,
          top: 50,
          bottom: 100
        },
        toolbox: {
          feature: {
            dataView: {},
            saveAsImage: {
                pixelRatio: 2
            }
          }
        },
        xAxis: {
          data: companyShortNames,
          silent: true,
          axisLabel: {
            interval: 0,
            rotate: -40,
            margin: 24
          },
          splitLine: {
              show: false
          }
        },
        yAxis: [{
          type: 'value',
          name: '业务保有量（万元）',
          position: 'left',
          min: 0,
          axisLabel: {
            formatter: '{value}万'
          }
        }],
        series: [{
          name: '业务保有量合计（万元）',
          type: 'bar',
          barGap: '-100%',
          data: bizRetentTotals,
          itemStyle: {
            color: '#DDDDDD'
          },
          barWidth: 20,
          label: {
            show: true,
            color: '#353535',
            position: 'top'
          }
        }, {
          name: '已签约的业务保有量（万元）',
          type: 'bar',
          stack: '总量',
          data: bizRetentContract,
          itemStyle: {
            color: '#334B5C'
          },
          barWidth: 20,
          label: {
            show: true,
            position: 'top'
          }
        },{
          name: '未签约的业务保有量（万元）',
          type: 'bar',
          stack: '总量',
          data: bizRetentNoContract,
          itemStyle: {
            color: '#738496'
          },
          barWidth: 20,
          label: {
            show: false
          }
        }]
    };

    var group_option = {
      legend: {
        data: ['一线人均业务保有量（万元）','全员人均业务保有量（万元）'],
        align: 'left'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        }
      },
      grid: {
        left: 70,
        right: 110,
        top: 50,
        bottom: 100
      },
      toolbox: {
        feature: {
          dataView: {},
          saveAsImage: {
            pixelRatio: 2
          }
        }
      },
      xAxis: {
        data: companyShortNames,
        silent: true,
        axisLabel: {
          interval: 0,
          rotate: -40,
          margin: 24
        },
        splitLine: {
          show: false
        }
      },
      yAxis: [{
        type: 'value',
        name: '人均业务保有量（万元）',
        position: 'left',
        min: 0,
        axisLabel: {
          formatter: '{value}万'
        }
      }],
      series: [{
          name: '一线人均业务保有量（万元）',
          type: 'bar',
          barWidth: '30%',
          barGap: '-100%',
          data: bizRetentTotalsPerWorker,
          itemStyle: {
            color: '#DDDDDD'
          },
          label: {
            show: true,
            color: '#353535',
            position: 'top'
          }
        },{
          name: '全员人均业务保有量（万元）',
          type: 'bar',
          stack: '实收',
          data: bizRetentTotalsPerStaff,
          itemStyle: {
            color: '#60A0A8'
          },
          barWidth: 20,
          label: {
            show: true,
            position: 'top',
            fontWeight: 'bold',
            color: '#000000'
          }
        },{
          name: '一线全员差额（万元）',
          type: 'bar',
          stack: '实收',
          data: bizRetentTotalsGap,
          itemStyle: {
            color: '#DDDDDD'
          },
          barWidth: 20,
          label: {
            show: false
          }
        }]
    };

    function drill_down_contract_hold_detail(params) {
      if (params.componentType === 'series') {
        if (params.seriesType === 'bar') {
          const company_name = companyShortNames[params.dataIndex];
          const company_code = companyCodes[params.dataIndex];
          const month_name = $('#month_name').val();
          const view_deptcode_sum = $('#view_deptcode_sum').val();
          let url;
          url = '/report/contract_hold?view_deptcode_sum=true&org_code=' + company_code + '&month_name=' + month_name + '&view_orgcode_sum=' + view_deptcode_sum;
          if (currentUserCompaniesShortNames.indexOf(company_name) > -1 || currentUserCompaniesShortNames.indexOf('上海天华') > -1) {
            Turbo.visit(url);
          }
        }
      }
    }
    this.groupContractHoldChart.setOption(option, false);
    this.groupContractHoldChart.on('click', drill_down_contract_hold_detail);
    this.groupContractHoldPerDeptChart.setOption(group_option, false);

    this.charts = [this.groupContractHoldChart, this.groupContractHoldPerDeptChart];
    this.updateTheme();
    this.themeObserver = new MutationObserver(() => this.updateTheme());
    this.themeObserver.observe(document.documentElement, {
      attributes: true, attributeFilter: ['data-coreui-theme', 'data-bs-theme']
    });
    this.resizeObserver = new ResizeObserver(() => this.layout());
    this.resizeObserver.observe(this.element);
  }

  updateTheme() {
    const styles = getComputedStyle(this.element);
    const text = styles.color;
    const background = styles.getPropertyValue('--cui-body-bg').trim() || '#fff';
    const dark = document.documentElement.getAttribute('data-coreui-theme') === 'dark';
    const colors = dark ? ['#b7c4d4', '#79b8ed', '#42c7b5'] : ['#dddddd', '#527da5', '#27695f'];

    this.charts.forEach((chart, index) => {
      chart.setOption({
        textStyle: { color: text },
        title: { textStyle: { color: text } },
        legend: { textStyle: { color: text }, inactiveColor: dark ? '#8993a3' : '#767676' },
        tooltip: { backgroundColor: background, borderColor: text, textStyle: { color: text }, confine: true },
        toolbox: {
          iconStyle: { borderColor: text },
          feature: { dataView: { backgroundColor: background, textareaColor: background, textColor: text }, saveAsImage: { backgroundColor: background } }
        },
        xAxis: { axisLabel: { color: text }, axisLine: { lineStyle: { color: text, opacity: 0.5 } } },
        yAxis: {
          axisLabel: { color: text }, nameTextStyle: { color: text },
          splitLine: { lineStyle: { color: text, opacity: 0.16 } }
        },
        series: Array.from({ length: 3 }, (_, seriesIndex) => ({
          itemStyle: { color: colors[index === 1 && seriesIndex === 2 ? 0 : seriesIndex] },
          label: { color: text, textBorderColor: background, textBorderWidth: 3, position: 'top', formatter: params => Number(params.value) === 0 ? '' : params.value },
          labelLayout: { hideOverlap: true }
        }))
      });
    });
  }

  layout() {
    this.groupContractHoldChart.resize();
    this.groupContractHoldPerDeptChart.resize();
  }

  disconnect() {
    this.themeObserver?.disconnect();
    this.resizeObserver?.disconnect();
    this.groupContractHoldChart.dispose();
    this.groupContractHoldPerDeptChart.dispose();
  }
}
